import { render, staticRenderFns } from "./BelgeTuruPicker.vue?vue&type=template&id=0bb5494b&scoped=true"
import script from "./BelgeTuruPicker.vue?vue&type=script&lang=ts"
export * from "./BelgeTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5494b",
  null
  
)

export default component.exports